/**
     * @desc 查询NFT作品
查询用户未上架的单个NFT作品信息
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/item/getItem', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/item/getItem', params);
}
